<template>
	<div v-if="body_show">
		<div>
      <div class="task-box task2">
        <div class="task-title">
          {{ pjtTitle }}
        </div>
        <div v-for="(item, index) in dynamicData" :class="[item.type === 'select2' ? 'in-block' : '', 'task2 task-plr-reset']">
          <!-- fill -->
          <div v-if="item.type === 'fill'" class="task_f">
            <h3 class="label">{{ item.label }}</h3>
            <div class="clearfix">
              <div v-if="item.yield" v-for="item2 in item.list" class="task_ninput pull-left">
                <span v-if="!item2.attr">{{item2.label}}</span>
                <input v-if="item2.attr" v-model="item2.value" type="text" class="task_n" />
                <span v-if="item2.attr">{{item2.label}}</span>
              </div>
            </div>
          </div>
          <!-- title -->
          <div v-if="item.type === 'title'" class="task_f">
            <h3 class="label">{{ item.label }}<span v-if="item.config">{{item.config.subtitle.text}}</span></h3>
          </div>
          <!-- tip -->
          <div v-if="item.type === 'tips'" class="task_f">
            <h3 class="label">{{item.label}}
              <span v-for="item2 in item.list" @click="showTagModul(item2.tip, item2.lab, item2.val)" :class="item2.tip ? 'noun' : ''" v-html="item2.tip ? item2.lab : item2"></span>
            </h3>
          </div>
          <!-- select1 -->
          <div v-if="item.type === 'select1'" class="cell project4-task-row clearfix">
            <div v-for="item2 in item.list" class="pull-left">
              <van-cell-group v-if="item2.attr" class="grouping project3-task1 pull-left clearfix">
                <van-field v-model="item2.value" @click="showPicker(item2.select, item2)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
              <span v-if="item2.attr" class="pull-left">{{item2.label}}</span>
              <span v-else class="pull-left">{{item2.label}}</span>
            </div>
          </div>
          <!-- select2 -->
          <div v-if="item.type === 'select2'" class="cell project4-task-row clearfix">
            <span class="pull-left">{{item.label}}</span>
            <van-cell-group class="grouping project3-task1 mt-reset pull-left clearfix">
              <van-field v-model="item.value" @click="showPicker(item.select, item)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
          </div>
          <!-- textarea -->
          <div v-if="item.type === 'textarea'" class="cell clearfix">
            <div class="task_f mt-reset clearfix">
              <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
              <div class="input-mt mt-reset">
                <textarea v-model="item.value" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips"></textarea>
              </div>
              <span class="float">{{item.value.length}}/{{item.config.length}}</span>
            </div>
          </div>
          <!-- uploadimg -->
          <div v-if="item.type === 'uploadimg'" class="pj-task-group pjt-alone-1">
            <div class="t-name">{{item.label}}</div>
            <div class="upload-img clearfix">
              <a v-if="uploadImgBool" href="javascript:;" @click="uploadImgHandle(item)">
                <img :src="item.value" />
              </a>
              <a href="javascript:;" v-else >
                <van-uploader  name="uploader" :after-read="onRead">
                  <img :src="item.value" />
                </van-uploader>
              </a>
              <p>(请上传自己的简历，图片格式)</p>
            </div>
          </div>
          <!-- text -->
          <div v-if="item.type === 'text'" class="cell clearfix">
            <div class="task_f clearfix">
              <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
              <div class="input-mt input-box mt-reset">
                <input v-model="item.value" type="text" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips" />
              </div>
              <span class="float">{{item.value.length}}/{{item.config.length}}</span>
            </div>
          </div>
          <!-- selectLocal -->
          <div v-if="item.type === 'selectLocal'" class="task_f p-task">
            <div class="label task_pb10">{{item.label}}</div>
            <div class="input-box pl-none">
              <van-cell-group class="grouping">
                <van-field placeholder="省/直辖市" v-model="item.value" @click="showLocalSelect(item)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
            </div>
          </div>
          <!-- selectApi -->
          <div v-if="item.type === 'selectApi'" class="task_f p-task">
            <div class="label task_pb10">{{item.label}}</div>
            <div class="input-box pl-none">
              <van-cell-group class="grouping">
                <van-field :placeholder="item.config.tips" v-model="item.value" @click="showPickerSelect(item)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
            </div>
          </div>
        </div>
        <div class="submitBtn">
          <button @click="dynDataSub" :class="verification() ? 'actice' : ''">提交</button>
        </div>
      </div>
    </div>
    <!-- 选择 select -->
    <van-popup v-model="picker_show" position="bottom">
      <van-picker show-toolbar :columns="selectList" @cancel="picker_show = false" @confirm="confirm" />
    </van-popup>
    <!-- 选择 行业 级联 selectApi -->
    <van-popup v-model="industry_picker" position="bottom">
      <van-picker show-toolbar :columns="selectIndustry" @cancel="industry_picker = false" @confirm="confirmIndustry" />
    </van-popup>
    <!-- 省市区 selectLocal -->
    <van-popup v-model="areaModul" position="bottom">
      <van-area ref="areas" :area-list="areaList" :columns-num="2" @confirm="confirmRegion" />
    </van-popup>
    <!-- 弹出标签 tips -->
    <van-popup class="explain" v-model="tagModul">
      <div>
        <h2>{{ tagModulData.title }}</h2>
        <div class="pps" v-html="tagModulData.content"></div>
      </div>
    </van-popup>
	</div>
</template>
<script>
  import { mobileOrWin } from "@/utils/tools"
	import { index, subtable, getprofession, getjob, upload_image,upload_image_file,save_image } from '@/api/course'
  import { shareCon } from "@/utils/wxconfig"
  import areaList  from '@/utils/area'
  import wx from "weixin-js-sdk"
  import request from '@/utils/request'
  let imgSrc = require('../../../assets/upload_img.png');
	export default {
		data(){
			return {
				body_show: false,
				//
				pjtTitle: "",
				//
        dynamicData: [],
        form_id: '',
        tagModul: false,
        areaModul: false,
        picker_show: false,
        industry_picker: false,
        tagModulData: {
            title: "默认标题",
            content: "默认标签提示内容"
        },
        selectItem: null,
        backupList: {},
        selectList: [],
        selectIndustry: [],
        areaList,
        //
        objArg: {
          cid: "",
          cpid: ""
      	},
        //
        selectItem: null,
        storageJSON: {},
        targetSelect: false,
        imgSrc: imgSrc,
        // 上传图片类型
        uploadImgBool:true,
        image_url:''
			}
		},
		methods: {
      // 上传图片判断
      onRead(files,detail){
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", files.file);
  
        // 上传图片接口
        upload_image_file(form).then((res) => {
          if (res.code ==10002) {
            this.$toast(res.msg);
            return
          }
          save_image({
            cid: this.$route.query.cid,
            head:res.image_url
          }).then(data => {
            this.dynamicData.forEach((index,item)=>{
              if(item.type == 'uploadimg'){
                item.value = res.image_url;
              }
            });
              // this.imgDefault = true;
            });
        });
      },
      // 弹出选择
      showPicker(select, item){
        this.picker_show = true;
        this.selectItem = item;
        this.selectList = select;
      },
      // 选择之后
      confirmIndustry(val, key){
        let item = this.targetSelect;
        item.value = val;
        this.industry_picker = false;
        // 是否清空子级内容
        if(!item.config.parentapi){
          let child = this.findItemChildren(item);
          child.value = '';
        }
      },
      // 查找关联子级
      findItemChildren(item){
        for(let arg of this.dynamicData){
          if(arg.type === 'selectApi' && item.config.api === arg.config.parentapi){
            return arg
          }
        }
      },
      // 查找关联父级
      findItemParent(item){
        for(let arg of this.dynamicData){
          if(arg.type === 'selectApi' && item.config.parentapi === arg.config.api){
            return arg
          }
        }
      },
      // 显示 && 判断是否需要提示用户先选关联的父级
      showPickerSelect(item){
        this.targetSelect = item;
        let isParent = item.config.parentapi;
        // let exitParent = Object.defineProperty(item.config, 'parentapi');
        // 二级
        if(isParent){
          // 判断暂存的父级是不是自己的父级
          let parent = this.findItemParent(item);
          if(!parent.value){
            // 提示用户先选父级
            this.$notify(`请先选择 ${parent.label}`);
            return
          }
          // 逻辑成立
          let parKey = parent.config.api;
          let itemIndex = this.storageJSON[parKey].attr[parent.value];
          let curSelectList = this.storageJSON[item.config.api][itemIndex]
          this.selectIndustry = curSelectList;
          this.industry_picker = true;
        }else{
          // 一级
          let key = item.config.api;
          this.selectIndustry = this.storageJSON[key]['item'];
          this.industry_picker = true;
        }
      },
      // 选择地址 - 显示
      showLocalSelect(item){
        this.selectItem = item;
        this.areaModul = true;
      },
      // 选择地区之后
      confirmRegion(arr){
        this.selectItem.value = `${arr[0].name}  ${arr[1].name}`;
        this.areaModul = false;
      },
      imgSave(item, serverId) {
        let q = this.$route.query;
        upload_image({
          cid: q.cid,
          server_id: serverId
        })
        .then(data => {
          item.value = data.headimgurl;
          // this.imgDefault = true;
        });
      },
      uploadImgHandle(item) {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                // this.serverId = res.serverId;
                this.imgSave(item, res.serverId);
              }
            });
          },

        });
      },
      // 提交动态数据
			dynDataSub(){
				let testResult = this.verification();
        if(!testResult){
            return
        }
        // loading
        this.$toast.loading({
            mask: true,
            message: "加载中..."
        });
        // 成立
        let getData = this.getDynData();
        // console.log(JSON.stringify(getData));
        let q = this.$route.query;
        subtable({
            cid: q.cid,
            type: "tasktwo",
            cpid: q.pid,
            cptid: q.id,
            form_id: this.form_id,
            field: JSON.stringify(getData)
        })
        .then((data) => {
            let q = this.$route.query;
            this.$toast.clear();
            this.objArg.cid = q.cid;
            this.objArg.cpid = q.pid;
            this.$router.push({path:'/project_report',query:this.objArg});
        })
			},
      // 提交数据前-加工成品数据
			getDynData(){
        let newData = []
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
              let conJson = {};
              for(let item of arg.list){
                if(item.attr){
                  conJson[item.attr] = item.value
                }
              }
              newData.push({
                'field_id': arg.id,
                'content': JSON.stringify(conJson)
              })
          }else if(arg.type === 'select2' || arg.type === 'textarea' || arg.type === 'uploadimg' || arg.type === 'text' || arg.type === 'selectLocal' || arg.type === 'selectApi'){
            newData.push({
              'field_id': arg.id,
              'content': arg.value
            })
          }
        }
        return newData
      },
      // 提交数据之前-验证数据
			verification(){
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
            for(let arg2 of arg.list){
              if(arg2.attr && !arg2.value){
                return
              }
            }
          }else if(arg.type === 'select2' || arg.type === 'textarea' || arg.type === 'uploadimg' || arg.type === 'text' || arg.type === 'selectLocal' || arg.type === 'selectApi'){
            if(!arg.value){
              return;
            }
            if(arg.type === 'textarea' && arg.value.length > arg.config.length){
              return;
            }
            if(arg.type === 'uploadimg' && arg.value == imgSrc) {
              return;
            }
          }
        }
        return true
      },
      // 显示标签弹窗-内容 tips
      showTagModul(bool, title, content){
        if(!bool){
            return
        }
        this.tagModul = true;
        this.tagModulData['title'] = title;
        this.tagModulData['content'] = content;
      },
      // 显示输入组长度
			changeVal(ev, item, maxLen){
				let tarLen = ev.target.value.length;
        if(tarLen > maxLen){
          item.value = item.value.substring(0, maxLen);
        }
			},
			pullData(){
				let q = this.$route.query;
				index({
					cid: q.cid,
          cpid: q.pid,
          cptid: q.id
				})
				.then((data) => {
          if(!mobileOrWin()){
            this.uploadImgBool = false;
          }
					this.pjtTitle = data.title;
					this.dynamicData = [];
					let isReset = !!data.userfield.length;

					let userData = data.userfield;
          let newJSON = {};

          for(let arg of userData){
            newJSON[arg.field_id] = arg.content;
          }

          // 没有编辑过
          let list = data.field;
          this.form_id = list[0].form_id;
          // 取默认数据
          for(let [i1, arg] of list.entries()){
            if(arg.type === 'fill'){
              // 存key
              let nk = {};
              for(let [index, arg2] of arg.config.text.entries()){
                if(arg2.attr){
                  arg2.value = '';
                  nk[arg2.attr] = index;
                }
                if(!isReset && arg2.attr){
                  arg2.value = arg.config.variable[arg2.attr].content;
                }
              }
              let nd = {
                id: arg.id,
                type: 'fill',
                yield: true,
                label: arg.label,
                back: nk,
                list: arg.config.text
              };
              if(isReset){
                let sc = JSON.parse(newJSON[nd.id]);
                for(let attr in nk){
                  let index = nk[attr];
                  let value = sc[attr];
                  nd.list[index].value = value;
                }
              }
              this.dynamicData.push(nd)
            }else if(arg.type === 'title'){
              this.dynamicData.push({
                id: arg.id,
                type: 'title',
                yield: false,
                config: arg.config,
                label: arg.label
              })
            }else if(arg.type === 'tips'){
              let j = arg.config.subtitle.difficult;
              let t = arg.config.subtitle.text;
              let key;
              for(let attr in j){
                key = attr;
              }
              let arr = t.split(key);
              arr[2] = arr[1].replace(/\n/ig, '<br/>');
              arr[1] = {
                tip: true,
                lab: key,
                val: j[key].content.replace(/\n/ig, '<br/>')
              }
              this.dynamicData.push({
                id: arg.id,
                type: 'tips',
                yield: true,
                label: arg.label,
                list: arr
              })
            }else if(arg.type === 'select'){
              let text = arg.config.text;
              let json = arg.config.variable;
              // 多项
              if(text){
                let nk = {}
                for(let [index, arg2] of text.entries()){
                  if(arg2.attr){
                    arg2.value = '';
                    arg2.select = json[arg2.attr].content;
                    nk[arg2.attr] = index;
                  }
                }
                let nd = {
                  id: arg.id,
                  type: 'select1',
                  yield: true,
                  back: nk,
                  list: text
                }
                if(isReset){
                  let sc = JSON.parse(newJSON[nd.id]);
                  for(let attr in nk){
                    let index = nk[attr];
                    let value = sc[attr];
                    nd.list[index].value = value;
                  }
                }
                this.dynamicData.push(nd)
              }else{
                let nd = {
                  id: arg.id,
                  type: 'select2',
                  yield: false,
                  value: '',
                  label: arg.label,
                  select: arg.config.content
                }
                if(isReset  && data.userfield[i1]){
                  nd.value = newJSON[nd.id]
                }
                this.dynamicData.push(nd)
              }
            }else if(arg.type === 'textarea'){
              let nd = {
                id: arg.id,
                type: 'textarea',
                yield: false,
                label: arg.label,
                tips: arg.config.subtitle ? arg.config.subtitle.text : false,
                value: '',
                config: {
                  tips: arg.config.placeholder,
                  length: arg.config.word
                }
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd)
            }else if(arg.type === 'uploadimg'){
              let nd = {
                id: arg.id,
                label: arg.label,
                value: imgSrc,
                type: 'uploadimg'
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd);
            }else if(arg.type === 'text'){
              let nd = {
                id: arg.id,
                label: arg.label,
                type: 'text',
                value: '',
                config: {
                  tips: arg.config.placeholder,
                  length: arg.config.word
                }
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd);
            }else if(arg.type === 'selectLocal'){
              let nd = {
                id: arg.id,
                label: arg.label,
                type: 'selectLocal',
                value: '',
                config: {
                  tips: arg.config.placeholder
                }
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd);
            }else if(arg.type === 'selectApi'){
              let nd = {
                id: arg.id,
                label: arg.label,
                type: 'selectApi',
                value: '',
                config: {
                  tips: arg.config.placeholder,
                  api: arg.config.api,
                  parentapi: arg.config.parentapi ? arg.config.parentapi : false
                }
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              let bool = !!nd.config.parentapi;
              this.getStorageData(nd.config.api, bool, i1);
              this.dynamicData.push(nd);
            }
          }
          console.log(this.dynamicData);
          this.body_show = true;
				})
			},
      // 根据api拉取动态列表数据
      getStorageData(url, bool, index){
        let promiseAjax = request({
          url: `/api/task/${url}`,
          method: 'POST',
          data: {}
        })
        promiseAjax.then((data) => {
          // 分辨是一级还是二级
          if(bool){
            // 先预置
            this.storageJSON[url] = {};
            //
            for(let arg of data){
              let itemVal = this.storageJSON[url][arg.pid];
              if(itemVal && itemVal.length){
                itemVal.push(arg.name);
              }else{
                this.storageJSON[url][arg.pid] = [arg.name]
              }
            }
          }else{
            this.storageJSON[url] = {
              attr: {},
              item: []
            };
            this.storageJSON[url]['index'] = index;
            let attr = this.storageJSON[url]['attr'];
            let item = this.storageJSON[url]['item'];
            for(let arg of data){
              attr[arg.name] = arg.id;
              item.push(arg.name)
            }
          }
        })
        // console.log(this.storageJSON);
      }
		},
		created(){
			this.pullData();
			shareCon("course",this);
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
  .pl-none{
    padding-left: 0!important;
  }
  .label{
    span{
      font-size: 0.32rem;
      color: #666;
    }
  }
  .task-box.task2{
    .task_f.mt-m{
      margin-top: 30px;
      h3{
          line-height: 1;
      }
    }
  }
  //
  .task-plr-reset{
    padding-left: 0;
    padding-right: 0;
  }
  .task_ninput{
    .task_n{
      width: 60px;
    }
  }
  .mt-reset{
    margin-top: 0!important;
  }
  .in-block{
    display: inline-block;
  }
  .task_pb10{
    padding-bottom: 10px;
  }
  .project4-task-row{
    color: #666;
    word-wrap: break-word;
    word-break: normal;
    span{
      height: 69px;
      line-height: 69px;
      padding: 0 10px;
      display: block;
    }
  }
  .pjt-alone-1{
    >.t-name{
      font-size: 0.426667rem;
      height: auto;
      color: #EB5032;
      float: none;
      padding-bottom: 10px;
    }
  }
</style>
<style>
	.project-alone-task1 .van-cell .van-cell__value input{
    width: 2.5rem;
  }
</style>